// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useState} from 'react';
import {Editor} from '../../shared/editor/editor';
import {lazy_importer} from '../../shared/lib/lazy_import';

const {Power_cards, Power_cards_editor} = lazy_importer(
    ()=>import('./ui/vs_oculus/power_cards'),
    'Power_cards', 'Power_cards_editor');
const {Use_case_hero, Use_case_hero_editor} = lazy_importer(
    ()=>import('./ui/use-cases/use_case_hero'),
    'Use_case_hero', 'Use_case_hero_editor');
const {Promo_card, Promo_card_editor} = lazy_importer(
    ()=>import('./ui/use-cases/promo_card'),
    'Promo_card', 'Promo_card_editor');
const {Other_use_cases, Other_use_cases_editor} = lazy_importer(
    ()=>import('./ui/use-cases/other_use_cases'),
    'Other_use_cases', 'Other_use_cases_editor');
const {Other_solutions, Other_solutions_editor} = lazy_importer(
    ()=>import('./ui/proxy-solutions/other_solutions'),
    'Other_solutions', 'Other_solutions_editor');
const {All_solutions_lobby, All_solutions_lobby_editor} = lazy_importer(
    ()=>import('./ui/proxy-solutions/all_solutions_lobby'),
    'All_solutions_lobby', 'All_solutions_lobby_editor');
const {Solutions_hero, Solutions_hero_editor} = lazy_importer(
    ()=>import('./ui/proxy-solutions/solutions_hero'),
    'Solutions_hero', 'Solutions_hero_editor');
const {Info_cards, Info_cards_editor} = lazy_importer(
    ()=>import('./ui/proxy-solutions/info_cards'),
    'Info_cards', 'Info_cards_editor');
const {Cases_info_cards, Cases_info_cards_editor} = lazy_importer(
    ()=>import('./ui/use-cases/cases_info_cards'),
    'Cases_info_cards', 'Cases_info_cards_editor');
const {Faq_lobby, Faq_lobby_editor} = lazy_importer(
    ()=>import('./ui/faq/faq_lobby'), 'Faq_lobby', 'Faq_lobby_editor');
const {Product_hero, Product_hero_editor} = lazy_importer(
    ()=>import('./ui/products/product_hero'),
    'Product_hero', 'Product_hero_editor');
const {Manage_product} = lazy_importer(
    ()=>import('./ui/products/manage_product'), 'Manage_product');
const {Product_use_case, Product_use_case_editor} = lazy_importer(
    ()=>import('./ui/products/product_use_case'),
    'Product_use_case', 'Product_use_case_editor');
const {All_cases_page, All_cases_page_editor} = lazy_importer(
    ()=>import('./ui/use-cases/all_cases_page'),
    'All_cases_page', 'All_cases_page_editor');
const {General_faq, General_faq_editor} = lazy_importer(
    ()=>import('./ui/homepage/general_faq'),
    'General_faq', 'General_faq_editor');
const {Article_widget, Article_widget_editor} = lazy_importer(
    ()=>import('./ui/blog/article_widget'),
    'Article_widget', 'Article_widget_editor');
const {Blog, Blog_editor} = lazy_importer(
    ()=>import('./ui/blog/blog'), 'Blog', 'Blog_editor');
const {Articles_section} = lazy_importer(
    ()=>import('./ui/blog/articles_section'), 'Articles_section');
const {Integration_hero} = lazy_importer(
    ()=>import('./ui/homepage/integration_hero'), 'Integration_hero');
const {Category_page} = lazy_importer(()=>import('./ui/blog/category_page'),
    'Category_page');
const {Integrations_hero_editor} = lazy_importer(
    ()=>import('../../toolip/pub/ui/integrations_hero/integrations_hero'),
    'Integrations_hero_editor');
const {Case_card, Case_card_editor} = lazy_importer(
    ()=>import('./ui/products/case_card'), 'Case_card', 'Case_card_editor');
const {Trustpilot_widget} = lazy_importer(
    ()=>import('./ui/content/trustpilot_widget'), 'Trustpilot_widget');
const {Use_cases} = lazy_importer(()=>import('./ui/homepage/use_cases'),
    'Use_cases');
const {Products_lobby} = lazy_importer(
    ()=>import('./ui/products/products_lobby'), 'Products_lobby');
const {Html, Html_editor} = lazy_importer(
    ()=>import('../../hola/pub/lib/html'), 'Html', 'Html_editor');
const {Hero: Hero_location} = lazy_importer(()=>import('./ui/location/hero'),
    'Hero');
const {Hero, Hero_editor} = lazy_importer(()=>import('./ui/content/hero'),
    'Hero', 'Hero_editor');
const {Products, Products_editor} = lazy_importer(
    ()=>import('./ui/homepage/products'), 'Products', 'Products_editor');
const {Pricing_lobby} = lazy_importer(
    ()=>import('./ui/pricing/pricing_lobby'), 'Pricing_lobby');
const {Why_oculus, Why_oculus_editor} = lazy_importer(
    ()=>import('./ui/homepage/why_oculus'),
    'Why_oculus', 'Why_oculus_editor');
const {Pricing_section, Pricing_section_editor} = lazy_importer(
    ()=>import('./ui/pricing/pricing_section'),
    'Pricing_section', 'Pricing_section_editor');
const {Check_products, Check_products_editor} = lazy_importer(
    ()=>import('./ui/pricing/check_products'),
    'Check_products', 'Check_products_editor');
const {Reviews} = lazy_importer(()=>import('./ui/homepage/reviews'),
    'Reviews');
const {HP_faq, HP_faq_editor} = lazy_importer(()=>import('./ui/homepage/faq'),
    'HP_faq', 'HP_faq_editor');
const {Top_locations} = lazy_importer(()=>import('./ui/common/top_locations'),
    'Top_locations');
const {Trust, Trust_editor} = lazy_importer(
    ()=>import('./ui/products_v2/trust'), 'Trust', 'Trust_editor');
const {Locations, Locations_editor} = lazy_importer(
    ()=>import('./ui/products_v2/locations'),
    'Locations', 'Locations_editor');
const {Lobby_hero} = lazy_importer(()=>import('./ui/products_v2/lobby_hero'),
    'Lobby_hero');
const {Compare_table, Compare_table_editor} = lazy_importer(
    ()=>import('./ui/products_v2/compare_table'),
    'Compare_table', 'Compare_table_editor');
const {Power_cards_v2, Power_cards_v2_editor} = lazy_importer(
    ()=>import('./ui/products_v2/power_cards_v2'),
    'Power_cards_v2', 'Power_cards_v2_editor');
const {Ethical, Ethical_editor} = lazy_importer(
    ()=>import('./ui/products_v2/ethical'), 'Ethical', 'Ethical_editor');
const {Cases, Cases_editor} = lazy_importer(
    ()=>import('./ui/products_v2/cases'), 'Cases', 'Cases_editor');
const {Resources} = lazy_importer(
    ()=>import('./ui/products_v2/resources'), 'Resources');
const {Reviews_v2} = lazy_importer(()=>import('./ui/products_v2/reviews'),
    'Reviews_v2');
const {Faq_v2, Faq_v2_editor} = lazy_importer(
    ()=>import('./ui/products_v2/faq_v2'), 'Faq_v2', 'Faq_v2_editor');
const {Product_hero_v2, Product_hero_v2_editor} = lazy_importer(
    ()=>import('./ui/products_v2/product_hero_v2'),
    'Product_hero_v2', 'Product_hero_v2_editor');
const {Info_card, Info_card_editor} = lazy_importer(
    ()=>import('./ui/products_v2/info_card'), 'Info_card', 'Info_card_editor');
const {Specs, Specs_editor} = lazy_importer(
    ()=>import('./ui/products_v2/specs'), 'Specs', 'Specs_editor');
const {Pricing_section_v2, Pricing_section_v2_editor} = lazy_importer(
    ()=>import('./ui/pricing/pricing_section_v2'),
    'Pricing_section_v2', 'Pricing_section_v2_editor');
const {Workflow, Workflow_editor} = lazy_importer(
    ()=>import('./ui/products_v2/workflow'), 'Workflow', 'Workflow_editor');
const {Code_snippet_seo, Code_snippet_seo_editor} = lazy_importer(
    ()=>import('./ui/products_v2/code_snippet_seo'),
    'Code_snippet_seo', 'Code_snippet_seo_editor');
const {Scale_banner} = lazy_importer(
    ()=>import('./ui/products_v2/scale_banner'), 'Scale_banner');

export const static_resolvers = {
    'Html': {
        tag: Html,
        editor: Html_editor,
        props: {
            html: `<h2>Title</h2><p>Text in p1</p>
              <p class="p2">Text in p.p2</p>
              <p class="p12 semi">Text with class p12 and semi</p>`,
        },
    },
    'Hero': {
        tag: Hero,
        editor: Hero_editor,
    },
    'Hero_location': {
        tag: Hero_location,
    },
    'Top_locations': {
        tag: Top_locations,
    },
    'Products': {
        tag: Products,
        editor: Products_editor,
    },
    'Why_oculus': {
        tag: Why_oculus,
        editor: Why_oculus_editor,
    },
    'Pricing_lobby': {
        tag: Pricing_lobby,
    },
    'Pricing_section': {
        tag: Pricing_section,
        editor: Pricing_section_editor,
    },
    'Pricing_section_v2': {
        tag: Pricing_section_v2,
        editor: Pricing_section_v2_editor,
    },
    'Check_products': {
        tag: Check_products,
        editor: Check_products_editor,
    },
    'Reviews': {
        tag: Reviews,
    },
    'HP_faq': {
        tag: HP_faq,
        editor: HP_faq_editor,
    },
    'General_faq': {
        tag: General_faq,
        editor: General_faq_editor,
    },
    'Faq_lobby': {
        tag: Faq_lobby,
        editor: Faq_lobby_editor,
    },
    'Spacer': {
        tag: p=><div style={{height: p.height}}/>,
        editor: p=>{
            const [state, set_state] = useState(p.value);
            return <Editor
              value={state}
              editors={[{key: 'height', label: 'height', type: 'text'}]}
              on_change={v=>set_state(v)}
              on_save={()=>p.on_change(state)}
              on_cancel={p.on_cancel}/>;
        },
    },
    'Article_widget': {
        tag: Article_widget,
        editor: Article_widget_editor
    },
    'Blog': {
        tag: Blog,
        editor: Blog_editor,
    },
    'Articles_section': {
        tag: Articles_section,
    },
    'Integration_hero': {
        tag: Integration_hero,
        editor: Integrations_hero_editor,
    },
    'Category_page': {
        tag: Category_page,
    },
    'Case_card': {
        tag: Case_card,
        editor: Case_card_editor,
    },
    'Trustpilot_widget': {
        tag: Trustpilot_widget,
    },
    'Use_cases': {
        tag: Use_cases,
    },
    'Products_lobby': {
        tag: Products_lobby,
        editor: Products_editor
    },
    'Product_hero': {
        tag: Product_hero,
        editor: Product_hero_editor,
    },
    'Product_hero_v2': {
        tag: Product_hero_v2,
        editor: Product_hero_v2_editor,
    },
    'Info_card': {
        tag: Info_card,
        editor: Info_card_editor,
    },
    'Specs': {
        tag: Specs,
        editor: Specs_editor,
    },
    'Manage_product': {
        tag: Manage_product,
    },
    'Product_use_case': {
        tag: Product_use_case,
        editor: Product_use_case_editor,
    },
    'All_cases_page': {
        tag: All_cases_page,
        editor: All_cases_page_editor,
    },
    'Power_cards': {
        tag: Power_cards,
        editor: Power_cards_editor,
    },
    'Info_cards': {
        tag: Info_cards,
        editor: Info_cards_editor,
    },
    'Cases_info_cards': {
        tag: Cases_info_cards,
        editor: Cases_info_cards_editor,
    },
    'Use_case_hero': {
        tag: Use_case_hero,
        editor: Use_case_hero_editor,
    },
    'Promo_Card': {
        tag: Promo_card,
        editor: Promo_card_editor
    },
    'Other_use_cases': {
        tag: Other_use_cases,
        editor: Other_use_cases_editor
    },
    'Other_solutions': {
        tag: Other_solutions,
        editor: Other_solutions_editor
    },
    'All_solutions_lobby': {
        tag: All_solutions_lobby,
        editor: All_solutions_lobby_editor
    },
    'Solutions_hero': {
        tag: Solutions_hero,
        editor: Solutions_hero_editor
    },
    'Lobby_hero': {
        tag: Lobby_hero
    },
    'Trust': {
        tag: Trust,
        editor: Trust_editor
    },
    'Locations': {
        tag: Locations,
        editor: Locations_editor,
    },
    'Compare_table': {
        tag: Compare_table,
        editor: Compare_table_editor
    },
    'Power_cards_v2': {
        tag: Power_cards_v2,
        editor: Power_cards_v2_editor,
    },
    'Ethical': {
        tag: Ethical,
        editor: Ethical_editor,
    },
    'Cases': {
        tag: Cases,
        editor: Cases_editor,
    },
    'Resources': {
        tag: Resources
    },
    'Reviews_v2': {
        tag: Reviews_v2
    },
    'Faq_v2': {
        tag: Faq_v2,
        editor: Faq_v2_editor,
    },
    'Workflow': {
        tag: Workflow,
        editor: Workflow_editor,
    },
    'Code_snippet_seo': {
        tag: Code_snippet_seo,
        editor: Code_snippet_seo_editor
    },
    'Scale_banner': {
        tag: Scale_banner,
    },
};
